module.exports = __webpack_public_path__ + "static/img/icon_jingyin_dianji_40px.1090a27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_jingyin_dianji_40px.png
// module id = kkCm
// module chunks = 136